export default __webpack_public_path__ + "static/1-1d48118405a182df5a2f1bf21532a204.jpeg";